import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from "element-ui"
import 'element-ui/lib/theme-chalk/index.css'
import 'default-passive-events'
import '../utils/rem'
import './Json/globalComponents.js'
import tool from "../utils/tool";

Vue.use(ElementUI)
Vue.use(tool);
import axios from 'axios'
Vue.prototype.$axios = axios
Vue.config.productionTip = false

import VueI18n from 'vue-i18n'
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: "zh",
  messages: {
    zh: require("./assets/i18n/zh"),
    en: require("./assets/i18n/en")
  }
});

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')


